if (typeof window.modal === "undefined") {
  const modal = (window.modal = {
    init: function () {
      // closing through overlay click
      document.querySelectorAll(".modal-overlay").forEach(function (el) {
        el.addEventListener("click", function (e) {
          if (e.target.closest(".modal")) {
            return;
          }
          this.classList.remove("show-modal");
        });
      });

      // closing through close button click
      document
        .querySelectorAll(".modal-close, .modal-close-button")
        .forEach(function (el) {
          el.addEventListener("click", function () {
            this.closest(".modal-overlay").classList.remove("show-modal");
          });
        });

      // selecting an offer
      document
        .querySelectorAll(".modal .offers button")
        .forEach(function (clickedOfferButton) {
          clickedOfferButton.addEventListener("click", function () {
            this.closest(".offers")
              .querySelectorAll("button")
              .forEach(function (offerButton) {
                offerButton.classList.remove("selected");
              });
            this.classList.add("selected");
            // also, if in gift modal - activate the submit button
            this.closest(".gift-modal")
              ?.querySelector(".button")
              .classList.add("active");
          });
        });

      // month toggle
      document.querySelectorAll(".month-toggle p").forEach(function (toggle) {
        const giftInfoModal = toggle.closest(".gift-info-modal");
        const isLower = toggle.classList.contains("three");
        toggle.addEventListener("click", function () {
          giftInfoModal
            .querySelectorAll(".modal-header")
            .forEach(function (modalHeader) {
              if (
                (modalHeader.classList.contains("modal-header-lower") &&
                  isLower) ||
                (modalHeader.classList.contains("modal-header-higher") &&
                  !isLower)
              ) {
                modalHeader.style.display = "block";
              } else {
                modalHeader.style.display = "none";
              }
            });
          giftInfoModal
            .querySelector(".month-toggle .three")
            .classList.toggle("selected", isLower);
          giftInfoModal
            .querySelector(".month-toggle .six")
            .classList.toggle("selected", !isLower);
        });
      });

      // Upsell modal add to cart handler
      document
        .querySelectorAll(".complementary-product .js-add-upsell-btn")
        .forEach(function (button) {
          button.addEventListener("click", function (e) {
            e.preventDefault();

            const upsellModal = e.target.closest(".modal");
            const originalCartItemJSON = upsellModal.dataset.cartItem;
            console.log("originalCartItemJSON", originalCartItemJSON);
            const noCheckoutRedirect =
              upsellModal.dataset.noCheckoutRedirect == "1";
            const isGiftEligible = upsellModal.dataset.isGiftEligible == "1";

            if (!originalCartItemJSON) {
              console.error("No original cart item found");
              return false;
            }

            const originalCartItem = JSON.parse(originalCartItemJSON);
            console.log("Original cart item:", originalCartItem);

            // Get the selected upsell product
            const upsellSelector = upsellModal.querySelector(".pdp-selector");
            const selectedCard = upsellSelector?.querySelector(
              ".pdp-card.pdp-active"
            );

            if (selectedCard) {
              // Create upsell cart item
              const isSS = selectedCard.classList.contains("pdp-card-single");
              const qty = isSS
                ? selectedCard.querySelector(".pdp-card-ss-qty-dropdown select")
                    ?.value
                : selectedCard.dataset.qty;

              const upsellCartItem = {
                id: selectedCard.dataset.variantId,
                quantity: parseInt(qty),
                properties:
                  priceSelectorV2.getIgPricesForSelector(upsellSelector),
              };

              if (selectedCard.dataset.sellingPlan) {
                upsellCartItem.selling_plan = selectedCard.dataset.sellingPlan;
              }

              console.log("Upsell cart item:", upsellCartItem);

              // Close the upsell modal
              upsellModal
                .closest(".modal-overlay")
                .classList.remove("show-modal");

              // Check to show gift modal
              const giftModalOverlay = document.querySelector(
                ".gift-modal-overlay"
              );

              if (isGiftEligible && giftModalOverlay) {
                // add both original item &  upsell item -- store for later use when gift is selected
                const cartItems = [originalCartItem, upsellCartItem];
                giftModalOverlay.querySelector(".modal").dataset.cartItems =
                  JSON.stringify(cartItems);
                giftModalOverlay.querySelector(
                  ".modal"
                ).dataset.noCheckoutRedirect = noCheckoutRedirect ? 1 : 0;

                giftModalOverlay.classList.add("show-modal");
              } else {
                // No gift modal needed, add both items to cart now
                if (
                  typeof window.priceSelectorV2.addMultipleItemsToCart ===
                  "function"
                ) {
                  window.priceSelectorV2.addMultipleItemsToCart(
                    [originalCartItem, upsellCartItem],
                    null,
                    noCheckoutRedirect
                  );
                } else {
                  console.error("addMultipleItemsToCart function not found");
                  // Fallback: just add the original item
                  window.priceSelectorV2.addToCart(
                    originalCartItem,
                    null,
                    noCheckoutRedirect
                  );
                }
              }
            } else {
              console.error("No upsell product selected");
            }
          });
        });

      // "No Thanks" button handler
      document
        .querySelectorAll(".complementary-product .js-decline-upsell-btn")
        .forEach(function (button) {
          button.addEventListener("click", function (e) {
            e.preventDefault();

            const upsellModal = e.target.closest(".modal");
            const originalCartItemJSON = upsellModal.dataset.cartItem;
            const noCheckoutRedirect =
              upsellModal.dataset.noCheckoutRedirect == "1";
            const isGiftEligible = upsellModal.dataset.isGiftEligible == "1";

            if (!originalCartItemJSON) {
              return false;
            }

            const originalCartItem = JSON.parse(originalCartItemJSON);
            console.log(
              "Declining upsell, proceeding with original item:",
              originalCartItem
            );

            // Close the upsell modal
            upsellModal
              .closest(".modal-overlay")
              .classList.remove("show-modal");

            // Check if we need to show gift modal
            const giftModalOverlay = document.querySelector(
              ".gift-modal-overlay"
            );

            if (isGiftEligible && giftModalOverlay) {
              giftModalOverlay.querySelector(".modal").dataset.cartItem =
                originalCartItemJSON;
              giftModalOverlay.querySelector(
                ".modal"
              ).dataset.noCheckoutRedirect = noCheckoutRedirect ? 1 : 0;
              giftModalOverlay.classList.add("show-modal");
            } else {
              // No gift modal needed, add original item to cart
              window.priceSelectorV2.addToCart(
                originalCartItem,
                null,
                noCheckoutRedirect
              );
            }
          });
        });

      // gift modal - submit
      document
        .querySelectorAll(".gift-modal a.button")
        .forEach(function (button) {
          const giftModal = button.closest(".gift-modal");
          button.addEventListener("click", function (e) {
            e.stopPropagation();
            const giftVariantId = giftModal.querySelector(
              ".offers button.selected"
            )?.dataset.gid;

            // Check if we have multiple cart items or just one
            const cartItemsJSON = giftModal.dataset.cartItems;
            console.log("cartItemsJSON", cartItemsJSON);
            const cartItemJSON = giftModal.dataset.cartItem;

            if (!giftVariantId || (!cartItemsJSON && !cartItemJSON)) {
              return false;
            }

            if (!cartItemsJSON && !cartItemJSON) {
              console.error("No cart items found");
              return false;
            }

            const noCheckoutRedirect =
              giftModal.dataset?.noCheckoutRedirect == "1";

            if (cartItemsJSON) {
              // We have multiple items (original + upsell)
              try {
                const cartItems = JSON.parse(cartItemsJSON);
                console.log(
                  "Adding multiple items with gift:",
                  cartItems,
                  giftVariantId
                );

                //addMultipleItemsToCart(cartItems, giftVariantId, noCheckoutRedirect);
                if (
                  typeof window.priceSelectorV2.addMultipleItemsToCart ===
                  "function"
                ) {
                  window.priceSelectorV2.addMultipleItemsToCart(
                    cartItems,
                    giftVariantId,
                    noCheckoutRedirect
                  );
                } else {
                  console.error("addMultipleItemsToCart function not found");
                  // Fallback: add items one by one using the existing method
                  window.priceSelectorV2.addToCart(
                    cartItems[0],
                    giftVariantId,
                    noCheckoutRedirect
                  );
                }
              } catch (e) {
                console.error("Error parsing cart items:", e);
              }
            } else {
              // just one item (original only)
              const cartItem = JSON.parse(cartItemJSON);
              console.log(
                "Adding single item with gift:",
                cartItem,
                giftVariantId
              );
              window.priceSelectorV2.addToCart(
                cartItem,
                giftVariantId,
                noCheckoutRedirect
              );
            }

            return false;
          });
        });

      // benefits modal
      document.querySelectorAll(".benefits-link").forEach(function (link) {
        link.addEventListener("click", function () {
          document
            .querySelector(".benefits-modal-overlay")
            ?.classList.add("show-modal");
        });
      });

      // dieticians modal mobile

      document
        .querySelectorAll(".dietician-mobile-link")
        .forEach(function (link) {
          link.addEventListener("click", function () {
            document
              .querySelector(".dietician-modal-overlay")
              ?.classList.add("show-modal");
          });
        });

      // sub n save popup
      document
        .querySelectorAll('a[href="#sub-and-save"]')
        .forEach(function (link) {
          link.addEventListener("click", function () {
            document
              .querySelector(".subscribe-and-save-popup-container")
              ?.classList.add("show-modal");
          });
        });

      // product ingredients modal
      document.querySelectorAll(".show-ingredients").forEach(function (link) {
        link.addEventListener("click", function () {
          document
            .querySelector(".ingredients-modal-overlay")
            ?.classList.add("show-modal");
        });
      });

      // product-popup modal
      this.setProductModalEvents();
    },

    setProductModalEvents: function () {
      const openProductModal = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // parent container is card-wrapper on collections page & info-wrapper on PDP
        const parentContainer =
          e.currentTarget.closest(".card-wrapper") ||
          e.currentTarget.closest(".product__info-wrapper");

        const modalOverlay = parentContainer?.querySelector(
          ".product-modal-overlay"
        );

        modalOverlay?.classList.add("show-modal");
        modalOverlay?.querySelector("product-popup")?.updateGallery();
      };

      document
        .querySelectorAll(".js-open-product-modal")
        .forEach(function (linkEl) {
          linkEl.removeEventListener("click", openProductModal);
          linkEl.addEventListener("click", openProductModal);
        });
    },
  });

  document.addEventListener("DOMContentLoaded", function () {
    modal.init();
  });
}
